import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = {
  key: 0,
  class: "error-message"
}
const _hoisted_3 = {
  key: 0,
  class: "overlay"
}
const _hoisted_4 = { class: "overlay-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "login-card",
      shadow: "hover"
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "login-title" }, "Сброс пароля", -1)),
        _createVNode(_component_el_form, {
          onSubmit: _withModifiers(_ctx.handleResetPassword, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                  placeholder: "Username",
                  "prefix-icon": "el-icon-user",
                  autocomplete: "off",
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  loading: _ctx.isLoading,
                  type: "primary",
                  onClick: _ctx.handleResetPassword,
                  block: ""
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Сбросить пароль с использованием ЭЦП")
                  ])),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, [
              _createElementVNode("i", null, "При успешном сбросе пароль вы на экране увидите временный пароль!")
            ], -1)),
            _cache[3] || (_cache[3] = _createElementVNode("a", {
              href: "/login",
              style: {"font-size":"15px"}
            }, "Назар к страницу авторизаций", -1))
          ]),
          _: 1
        }, 8, ["onSubmit"]),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_icon, {
              class: "is-loading",
              size: "20"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Loading)
              ]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createTextVNode(" Пожалуйста, подпишите с помощью ЭЦП и дождитесь ответа от сервера для получения временного пароля. "))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}